<template>
    <div class="wrap-plashka" @click.stop="hideReminder" v-if="showReminder">
        <div  class="reminder" @click.stop>
            <slot class="slot-plashka"></slot>
            <button @click="closeReminder" class="button-plashka">Close</button>
        </div>
    </div>
  </template>

  <script>

  export default {
    name: 'plashka-modal',
    props: {
        showReminder: {
            type: Boolean,
            default: false
        }

    },
    data() {
        return {
        }
    },
     methods: {
        hideReminder() {
            this.$emit('update:showReminder', false)
        },
        closeReminder() {
            this.$emit('update:showReminder', false)

        }
     }

  }
</script>

<style scoped>
.wrap-plashka {
     position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.02);
    z-index: 999;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.reminder {
    width: 250px;
    height: auto;
    border: 1px solid gray;
    border-radius: 5px;
    background: white;
    padding: 10px;
    position: absolute;
    /* top: 50px; */
    /* right: 50px; */
    color: black;
    text-align: start;
    z-index: 999;
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.button-plashka {
    align-self: end;
}
.slot-plashka {
    display: block;
    margin: 5px;
}
</style>